<template>
  <div class="container">
    <donut-page-title :title="$i18n.t('shoutouts.feature')" />
    <donut-alert
      v-if="showAvailableBanner"
      class="m-bx2"
      theme="success"
      title="New: Shoutouts for peer-to-peer recognition is part of your plan"
      message="Reward and amplify your team's best work with Shoutouts, peer-to-peer recognition points delivered in Slack and redeemable in your custom Rewards Store."
    />
    <div class="f-as m-tx2">
      <!-- Video Card -->
      <div class="bg-light-purple br-4 w-x54 w-min-x54 p-hx2 p-vx2">
        <div class="f m-bx1">
          <lucide-icon name="Megaphone" :stroke-width="2" class="purple" />
          <div class="t-lg bold m-l">{{ $i18n.t('shoutouts.feature') }}</div>
        </div>
        <div class="t-sm italic gray">{{ description }}</div>
        <donut-storylane-preview
          id="0jf07gh1s3xn"
          class="br-8 m-tx1 mask"
          title="Shoutouts — Get started"
        />
      </div>

      <shoutouts-programs-setup-form v-bind="props" />
    </div>
  </div>
</template>

<script setup>
import { computed, inject } from 'vue';

const $i18n = inject('$i18n');

const props = defineProps({
  reauthData: { type: Object, default: null },
  program: { type: Object, required: true },
  noAccessReason: { type: String, default: null },
  shoutoutsAdmins: { type: Array, default: null },
  boostToggleDescription: { type: String, default: null },
  showAvailableBanner: { type: Boolean, default: false },
});

const description = computed(() => `Donut helps your team recognize great work and celebrate wins with ${$i18n.t('shoutouts.feature')}: personalized`
    + ` ${$i18n.t('shoutouts.shoutout', { count: 2 })} that spread positivity and fit your team's culture, all within Slack.`);
</script>
